/**
 * @generated SignedSource<<127e4da690ff827c6a273c63d18cf81f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessModelSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "AccessModelSettingsPage_query";
};
export type AccessModelSettingsPage_query$key = {
  readonly " $data"?: AccessModelSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessModelSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccessModelSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "65996c4bdc4db806fc3da258818059eb";

export default node;
